import React from "react";
import SettingsTab from "../SettingsTab";
import {
  Spinner,
  Button,
  Intent,
  FormGroup,
  TextArea,
  Callout
} from "@blueprintjs/core";
import { Toolbar, ToolbarGroup } from "../../../molecules/Toolbar";
import SettingsForm from "../SettingsForm";
import FormInfo from "../../../atoms/FormInfo/FormInfo";
import { useChangePoliticalInfo } from "./hook";

export default function PoliticalSettings() {
  const {
    politicalDisclaimer,
    setPoliticalDisclaimer,
    isSaving,
    error,
    saveChanges,
    loading,
    isSaveEnabled
  } = useChangePoliticalInfo();

  if (loading) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }

  return (
    <SettingsTab>
      <Toolbar title="Settings">
        <ToolbarGroup>
          <Button
            text="Save"
            intent={Intent.PRIMARY}
            loading={isSaving}
            disabled={!isSaveEnabled}
            onClick={saveChanges}
          />
        </ToolbarGroup>
      </Toolbar>

      <SettingsForm>
        {error && (
          <Callout
            icon="error"
            intent={Intent.DANGER}
            title="We couldn't save your settings."
          >
            {error.message}
          </Callout>
        )}

        <FormGroup label="Political Disclaimer">
          <FormInfo>
            Please provide any political disclaimers you need to disclose for
            your donations or products. These disclaimers will be displayed to
            the user in the first step of checkout when they choose to purchase
            or donate through your videos.
          </FormInfo>
        </FormGroup>

        <FormGroup
          label="Political Disclaimer"
          helperText="Markdown is enabled for this field."
        >
          <TextArea
            style={{ height: "50vh" }}
            large
            fill
            value={politicalDisclaimer}
            placeholder="Enter political disclaimer to be displayed at checkout"
            onChange={setPoliticalDisclaimer}
          />
        </FormGroup>
      </SettingsForm>
    </SettingsTab>
  );
}
